import MobileTitleBar from "components/MobileTitleBar"
import Price from "components/Price/Price"
import Badge from "components/Product/Badge"
import ProductCard from "components/Product/ProductCard"
import ProductFullscreen from "components/Product/ProductFullscreen"
import ProductImages from "components/Product/ProductImages"
import ProductList from "components/Product/ProductList"
import ProductPrice from "components/Product/ProductPrice"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import ProductSearch from "components/Product/ProductSearch"
import ProductSearchExtra from "components/Product/ProductSearchExtra"
import ProductTechnicalTable from "components/Product/ProductTechnicalTable"
import ProductPath from "components/ProductPath"
import Variants from "components/Variants/Variants"
import {Col, Row} from "elemental-react16"
import _ from "lodash"
import PropTypes from "prop-types"
import React, {Component} from "react"
import Responsive from "react-responsive"
import {Link} from "react-router-dom"
import {Button, Card, Container, Icon, Input, Label, Message, Popup, Select, Table} from "semantic-ui-react"
import shop from "shop/shop"

import productStore from "stores/productStore"
import "style/ProductPage.scss"

let lastProducts = null

const IconImage = ( {src, description} ) => <Popup content={description}
												   trigger={<img className="mr2 icon-product-attribute" width="42"
																 src={src} alt="" />} />

export default class ProductPage extends Component {

	componentWillUnmount() {
		document.body.classList.remove( "no-scroll" )
	}

	constructor( props ) {
		const {match} = props
		super()
		this.state = {
			id               : match.params.productId,
			product          : {},
			fullscreenElement: null,
			variants         : false,
			count: 1
		}
	}

	loadProduct( id ) {
		if ( this.id === id ) return
		this.id = id
		productStore.get( id )
			.then( product => {
				console.log( "ProductPage::product", product )
				product.count = 1
				let inCart = shop.cart.productsById.get( product.map_id )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				lastProducts = shop.analytics.lastProducts( 4 )
					.filter( ( id ) => id !== product.map_id )
				this.setState( {product: product, primaryImage: false} )

				if ( !product.mainart ) return
				productStore.partlist( product.mainart )
					.then( variants => {

						// let colors = variants.products.map( product => {
						//   return {
						//     color:  product.extraValue.Farbe,
						//     map_id: product.map_id
						//   }
						// } )

						let byAttribute = {}
						variants.variants.varfields.forEach( varfield => {
							
							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							_( categories ).keys().sort().each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered

						} )
						this.setState( {variants, byAttribute} )
					} )
			} )
			.catch( err => {
				console.error( `Product not available ${id}` )
				console.error( err )
				this.setState( {error: true} )
			} )
	}

	add = ( {product} ) => {
		//if ( product.count === 0 ) return shop.cart.remove( product )
		let ok = shop.cart.add( product )
		if ( ok ) shop.toast( `${product.count * product.unit_multi} Stück ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom" )

	}

	updateProduct = ( {product} ) => {
		this.setState( {product} )
	}

	componentWillReceiveProps( {match} ) {
		let {productId} = match.params
		this.loadProduct( productId )
	}

	showFullscreen = ( element ) => {
		this.setState( {
			fullscreenElement: element
		} )
	}

	setPrimaryImage = ( primaryImage ) => {
		this.setState( {primaryImage} )
	}

	componentDidMount() {
		this.loadProduct( this.state.id )
	}

	render() {
		let {fullscreenElement, product, byAttribute, primaryImage, error, count} = this.state

		if ( error ) return <div className={"vh-75 tc flex justify-center items-center"}>
			<div>
				<h3>404</h3>
				<div>Produkt nicht gefunden</div>
			</div>
		</div>

		if ( !product._type ) return null //  duck type check for ProductModel
		let img_srcs = product.img_srcs

		let category = product.cats[0] && product.cats[0] || {}
		let cat_id = category.cat_id

		let productImage
		if ( product.img_src ) {
			productImage = product.img_src_large
		}

		if ( primaryImage ) productImage = primaryImage

		// let categoryName = shop.categoryName(product.cats[0].cat_id)
		let path = shop.getCategoryPath( cat_id )

		path.push( {
			title: product.title,
			link : ""
		} )


		const veOptions = product.quantities.map( q => {
			return (
				{
					key  : q.map_desc_id,
					text : `${q.des} (${q.multi})`,
					value: q.map_desc_id
				}
			)
		} )

		let maxCount = Math.max(0, Math.floor(Number(product.extraValue.orderable_value) /product.unit_multi))
		console.log("shop.config:",shop.config.checkout.limitToStock,"count",count,"maxcount",maxCount,"prodcatdict",product.categoryDict["23"])
        let showVEWarning = shop.config.checkout.limitToStock && (count > maxCount) && !product.categoryDict["23"]

        if (product.extraValue.orderable_value === "0") {
            maxCount = 3
            showVEWarning = true
        }

        if (product.extraValue.orderable_value === "" || product.extraValue.orderable_value === undefined) {
            maxCount = 999999999999
            showVEWarning = false
        }

		// const veOptions = [
		//   { key: 'all', text: 'All', value: 'all' },
		//   { key: 'articles', text: 'Articles', value: 'articles' },
		//   { key: 'products', text: 'Products', value: 'products' },
		// ]

		return (
			<div className="bg-white ">

				<MobileTitleBar>
					<ProductPath path={path} title={product.title} product={product} />
				</MobileTitleBar>

				<Container className="relative  ">
					<ProductFullscreen
						change={this.showFullscreen}
						images={img_srcs}
						image={fullscreenElement} />

					<Responsive minWidth={790}>
						<div className="db pv3 ">
							<ProductPath path={path} title={product.title} product={product} /> <br />
						</div>
					</Responsive>

					{/*<Breadcrumbs path={path}/>*/}
					<section className="product product-single pb6-ns pb5">
						<Row>
							<Col sm="1" md="1/2" lg="7/12" className="relative">
								<div className="absolute right-2 pr3"><Badge product={product} /></div>
								<ProductImages
									key={product.map_id}
									product={product} images={img_srcs} image={productImage}
									onClick={this.showFullscreen}
									onClickSecondary={this.setPrimaryImage} />
							</Col>
							<Col sm="1" md="1/2" lg="5/12">

								<TitleSection product={product} />

								{/*{shop.session && <ActionSection product={product}*/}
								{/*onChange={this.updateProduct}*/}
								{/*onAdd={this.add}/>*/}
								{/*}*/}

								{(product && product.canBeBought) && <div>
									{shop.session &&
									<div className="product-actions">
										{product &&
										<Input
											type="number" min={0} placeholder="1" defaultValue={product.count} action onChange={e => {
											this.setState( {count: e.target.value} )
										}
										}>
											<input />
											<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[0].map_desc_id}
													onChange={( e, data ) => {
														const {value} = data
														const ve = product.quantities.filter( q => q.map_desc_id === value )
														if ( !ve ) return
														product.unit_multi = ve[0].multi
														product.unit_id = ve[0].map_desc_id
														console.log( {data, e, value: e.target.value, target: e.target} )
													}
													}
											/>
											<Button color={"black"} icon={"shopping cart"} onClick={() => {
												product.count = this.state.count || 1
												console.info( "BUY", this.state.count, product.unit_multi, product.unit_id )
												this.add( {product} )
											}
											} />

										</Input>
										}

									</div>}

                                        {showVEWarning &&
                                        <Message color={"yellow"} className={"cf"}>
                                            <Button color={"yellow"} floated={"right"} onClick={() => {
                                                product.count = maxCount
                                                let count = maxCount
                                                this.setState({count, product})
                                            }}>Ok</Button>

                                            <div className="pt2"><Icon name="warning"/> {`Maximale Abnahmemenge: ${maxCount} ${product.unit_desc}`}</div>

                                            {/*<Popup trigger={<Button  icon="warning" color="yellow" title={`Maximale Abnahmemenge: ${maxCount} VE`}/>}*/}
                                            {/*       content={`Maximale Abnahmemenge: ${maxCount} ${product.unit_id}}`}/>*/}
                                        </Message>

                                        }

								</div>}

								

								<div><DescriptionSection product={product} /></div>
								{shop.session && <BulkPricing product={product} />}
								{!shop.session && <div>
									<p>
										{translate( "shop.please_login_for_product_details" )}
									</p>

									<div className="mw6">
										<div className="pb2">
											<Link to="/login"><Button fluid> {translate( "shop.login" )}</Button></Link>
										</div>
										<Link to="/customer_registration"><Button fluid> {translate( "shop.register" )}</Button></Link>
									</div>
								</div>}
								{shop.session && <ProductTechnicalTable product={product} />}

								<br />
								<br />
								<section>
									<Variants byAttribute={byAttribute} product={product} />									
									{/*{variants && variants.products && variants.products.map( variant => <ProductVariant key={variant.map_id} product={variant}/> )}*/}
									{/*<pre>{JSON.stringify( variants && variants.variants.varfields, null, 2 )}</pre>*/}
								</section>
							</Col>
						</Row>
					</section>
				</Container>


				{product.extraValue.Kollektion && <div className="bg-silver pv4">
					<Container>
						<section className=" pt3 pb5">

							<div className="cf relative pb3">
								{product.category.desc &&
								<Link to={`/collection-extra/Kollektion/${product.extraValue.Kollektion}`}><h2
									className="mt2 ttu">{`${translate("Mehr aus Kollektion")}  ${product.extraValue.Kollektion}`} <Icon
									name="chevron right" /></h2>
								</Link>}
							</div>

							<ProductSearchExtra
								count={4}
								start={0}
								extra={"Kollektion"}
								extraValue={product.extraValue.Kollektion}
								query="%%"
								repeat={ProductCard} />
						</section>

					</Container>
				</div>}

				{product.category && <div className="pv4">
					<Container>
						<section className="section-product-slider">
							<div className="cf relative pb3">
								{product.category.desc && <Button basic as={Link} to={`/collection/${product.category.map_id}`}><h2
									className="mt2 ttu">{`${translate("Mehr aus")} ${product.category.desc.des ||
								product.category.desc.short_des}`} <Icon name="chevron right" /></h2>
								</Button>}
							</div>

							<ProductSearch
								count={4}
								start={0}
								cats={[cat_id]}
								query="%%"
								repeat={ProductCard} />
						</section>
					</Container>
				</div>}

				<div className="pv4 bg-silver">
					<Container>
						{/*Product Slider "last viewed"*/}
						<section className="section-product-slider pv5">
							<h2 className="mt2  ttu">{translate("Zuletzt angesehen")}</h2>
							<ProductList
								count={4}
								start={0}
								list={lastProducts}
								repeat={ProductCard} />
						</section>
					</Container>
				</div>
			</div>
		)
	}
}

ProductPage.propTypes = {
	price: PropTypes.any
}


const ProductVariant = ( {product} ) => {
	return (
		<Card as={Link} to={`/product/${product.map_id}`}>
			<img className="ui image" src={product.img_src_medium} />
			<div>{product.extraValue.Art}</div>
			<div>{product.extraValue.Groesse}</div>
		</Card>
	)
}

const BulkPricing = ( {product} ) => {
	if ( !product.prices || product.prices.length === 1 ) return null
	return (

		<div>
			<h4>{translate("Staffelpreise")} </h4>
			<Table>
				<tbody>
				{product.prices.map( price => (
					<tr key={price.q}>
						<td> {price.q} {translate("Stück")}</td>
						<td><Price>{price.p}</Price></td>
					</tr>
				) )}
				</tbody>
			</Table>

		</div>
	)
}

const Fullscreen = ( {image, change, images} ) => {
	document.body.classList.remove( "no-scroll" )
	if ( !image ) {
		return null
	}
	window.scrollTo && window.scrollTo( 0, 0 )
	const imgs = _.map( images, ( {img_src_large, img_src_small}, key ) => {
		return (
			<img key={key}
				 onClick={() => {
					 change( img_src_large )
				 }}
				 className="img-thumbnail "
				 src={img_src_small} />
		)
	} )

	document.body.classList.add( "no-scroll" )
	return (
		<div className="fullscreen">
			<div className="ui pull-right"
				 style={{position: "relative"}}>
				<Button icon="close"
						basic
						onClick={() => {
							change( false )
						}} />
			</div>

			<div className="center-child "
				 onClick={() => {
					 change( false )
				 }}>
				<div className="zoom-out img-container">
					<img src={image} alt="" />
				</div>
			</div>

			<div className="ui ui-bottom pull-right ">
				<div className="product-images">
					{imgs}
				</div>
			</div>
		</div>
	)
}

Fullscreen.propTypes = {
	children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}


const AdditionalTable = ( {product} ) => {
	return (
		<section className="AdditionalTable">
			<Row>
				<Col sm="1" md="1" className="pb3">
					<div className="technischetabelle">
						<strong>weitere Details</strong>
						<table className="table-technical">
							<tbody>
							{product && shop.session.group !== "WERBE" ? <tr>
								<td>UVP inkl. MwSt.</td>
								<td className="text-right"><Price className="fw1">{product.extraValue.evkpre}</Price></td>
							</tr> : null}
							{product && shop.session.group === "WERBE" ? <tr>
								<td>Industriepreis Netto</td>
								<td className="text-right"><Price className="fw1">{product.extraValue.indpre}</Price></td>
							</tr> : null}
							{product ? <tr>
								<td>EAN</td>
								<td className="text-right">{product.barcode}</td>
							</tr> : null}
							</tbody>
						</table>
					</div>
				</Col>
			</Row>
		</section>
	)
}

AdditionalTable.propTypes = {
	product: PropTypes.object
}

const TitleSection = ( {product} ) => (
	<section className="product-title mb0 pb0">
		<div className="brand">{product.extraValue.herst !== "unbekannt" &&
		<Link to={`/brand/${product.extraValue.herst}`}>{product.extraValue.herst}</Link>}</div>
		<div className="title">{product.desc.short_des}</div>
		<div className="id pt2 pb2">{translate("Artikel-Nr.")}: {product.article_nr || product.article_id}</div>

		{product.extraValue.statusinfo && <Message>{product.extraValue.statusinfo}</Message>}
		


		{/* Price*/}
		{shop.session && <ProductPrice product={product} />}

		{/* Availability*/}
		{shop.config.useAvailability !== false && <Availability product={product} />}
		{/*<Availability product={product}/>*/}
	</section>
)

TitleSection.propTypes = {
	product: PropTypes.object
}

const Availability = ( {product} ) => {
	let notice = product.getNotice()
	return (
		<div className="availability">
			{notice}
		</div>
	)
}

const ActionSection = ( {product, onChange, onAdd} ) => {
	if ( !product.canBeBought ) return null
	const list = shop.orderlist.default
	return (
		<section className="product-actions pt2 pb4">
			<div style={{display: "inline-block "}}>
				<p>
					{product.count * product.unit_multi} Stück <Price
					className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>
				<ProductQuantityGroup product={product}
									  list={list}
									  showVE={false}
									  onChange={onChange}
									  onAdd={onAdd}
									  large />
			</div>
		</section>
	)
}

ActionSection.propTypes = {
	product : PropTypes.object,
	onChange: PropTypes.func,
	onAdd   : PropTypes.func,
}


const DescriptionSection = ( {product} ) => (
	
	<section className="description pv3 lh-copy">
		{product.desc.des.split('\n').map((line, i) => (<span key={i}>{line}<br/></span>))}
	</section>
)
DescriptionSection.propTypes = {
	product: PropTypes.object,
}


ProductImages.propTypes = {
	images : PropTypes.any,
	image  : PropTypes.any,
	onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/base/pages/ProductPage.js